import logo from "../logo.svg";
import "../App.css";
import { useEffect } from "react";
import "../styles.css";

function Home() {
  useEffect(() => {
    // insert script tag
    const script = document.createElement("script");
    script.src = process.env.REACT_APP_CS_JS_SCRIPT;
    // charitystack-embed as id
    script.id = "charitystack-embed";
    // set data-id to M_glZDDEVkfj
    script.dataset.id = "M_dby7G6Xtc5";
    // make script defer
    script.defer = true;
    // append script to head
    document.body.appendChild(script);

    // create an event listener that listens for a message from the iframe
    window.addEventListener("message", (event) => {
      if (event.data.action !== "IFRAME_LOADED") {
        return;
      }
      const data = JSON.parse(event.data.data);
      const iframeID = data.elementID;
      const iframe = document.getElementById(iframeID);

      console.log("iframeID", iframeID);
      console.log("iframe", iframe);

      // store css content from styles.css into a variable
      const cssContent = `
                #57f555bd-771f-4992-a749-65a98e5f328d-CS-fundraising-bar-pill-text-right {
                    opacity: 0 !important;
                }
                    #dcb87a10-4825-48a6-b005-970db53cf45f-CS-fundraising-bar-pill-text-right {
                    opacity: 0 !important;
                }
            `;

      // #dcb87a10-4825-48a6-b005-970db53cf45f-CS-fundraising-bar-pill {
      //         background-color: red !important;
      //     }

      //     #dcb87a10-4825-48a6-b005-970db53cf45f-CS-fundraising-bar-pill-text {
      //         font-size: 300px !important;
      //     }

      // send CSS content to iframe
      iframe.contentWindow.postMessage(
        {
          action: "ADD_CSS_CONTENT",
          entity: "CHARITYSTACK",
          sender: "PARENT_WEBSITE",
          receiver: "FUNDRAISING_BAR",
          data: cssContent,
          id: iframeID,
        },
        "*",
      );
    });
  }, []);

  return (
    <div className="App">
      {/* <div
                style={{
                    position: "fixed",
                    top: "0px",
                    width: "100%",
                    height: "100px",
                    background: "linear-gradient(to bottom, #0066ff, #ff0000)",
                    zIndex: "99999",
                }}></div> */}

      <div>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
        sollicitudin enim et dolor pellentesque, et aliquam velit vestibulum.
        Morbi condimentum felis eget tortor congue, id convallis turpis
        fringilla. Duis rutrum tellus et sapien
      </div>

      <div
        data-entity="FUNDRAISING_BAR"
        data-source="CharityStack"
        id="dcb87a10-4825-48a6-b005-970db53cf45f"
      ></div>

      {/* STANDARD EMBED FORMS */}
      <div
        data-entity="EMBED_FORM"
        data-source="CharityStack"
        id="8de21262-b9fd-4c33-adf7-e685915dd971"
      ></div>

      {/* SPONSORSHIP LEVEL DONATE EMBED FORM */}
      <div
        data-entity="EMBED_FORM"
        data-source="CharityStack"
        id="10e83b63-56fc-4d16-9963-2705c722840c"
      ></div>

      {/* GIVING LEVELS EMBED FORM */}
      <div
        data-entity="EMBED_FORM"
        data-source="CharityStack"
        id="14376c47-7757-4f7f-abba-68f465f4a117"
      ></div>

      {/* EVENT DONATE EMBED FORM */}
      <div
        data-entity="EVENT"
        data-source="CharityStack"
        id="7912f4b5-a4b1-4f1d-8b68-ea78d7e6bad5"
      ></div>

      <div>
        Cras ullamcorper, justo sit amet sagittis commodo, metus dui consequat
        urna, eget sollicitudin metus erat ut dui. Proin aliquam lacus sit amet
        dolor vulputate tincidunt. Proin gravida mauris ex, nec bibendum urna
        pulvinar vitae. Nullam non pharetra purus. Proin bibendum
      </div>
    </div>
  );
}

export default Home;
